var map = {
	"./ACRISURE_ITALIA_LOGO - Copia.webp": "eefa",
	"./ACRISURE_ITALIA_logoshort.jpg": "0908",
	"./__ACRISURE_ITALIA_LOGO.webp": "6358",
	"./__ACRISURE_ITALIA_logoshort.jpg": "490f",
	"./__logo_a.jpg": "91a9",
	"./b2b.png": "30f8",
	"./b2c.png": "a066",
	"./care.png": "2a2e7",
	"./crm.png": "cdf1",
	"./delivery-insurance.png": "2ac7",
	"./edi.png": "8aa0",
	"./insurance.png": "c548",
	"./insurance_2.png": "34c4",
	"./logo_a.jpg": "2edf",
	"./mes.png": "8738",
	"./mes_2.png": "4d93",
	"./policy.png": "41ef",
	"./projects.png": "84ce",
	"./scheduling.png": "1402",
	"./services.png": "1b1f",
	"./sync.png": "4a8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c614";